export default {
    data(){
        return {
            product_url: process.env.VUE_APP_API_URL_PRODUCT,
            menu_url: process.env.VUE_APP_API_URL_MENU,
            base_url: process.env.VUE_APP_BASE_URL,
            api_url: process.env.VUE_APP_API_URL
        }
    },
    methods:{
        onImgLoad (event) {
            event.target.src = 'https://user-images.githubusercontent.com/24848110/33519396-7e56363c-d79d-11e7-969b-09782f5ccbab.png';
        },
    }
}
